import React from "react";
import { Link } from "react-router-dom";

export function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-slate-50">
      <div className="max-w-4xl mx-auto px-4 py-16">
        <h1 className="text-3xl font-bold text-slate-900 mb-2">Privacy Policy</h1>
        <p className="text-slate-500 mb-8">Last updated: December 18, 2025</p>

        <div className="bg-white rounded-2xl shadow-lg p-8 space-y-8">
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">1. Information We Collect</h2>
            <div className="text-slate-600 leading-relaxed space-y-4">
              <p><strong>Account Information:</strong> Name, email address, phone number, business name, and billing information when you create an account.</p>
              <p><strong>Call Data:</strong> Phone numbers of callers, call recordings, call transcripts, call summaries, and call metadata (duration, time, etc.).</p>
              <p><strong>Usage Data:</strong> How you interact with our dashboard, features used, and service metrics.</p>
              <p><strong>Technical Data:</strong> IP address, browser type, device information, and cookies.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">2. How We Use Your Information</h2>
            <ul className="list-disc list-inside text-slate-600 space-y-2">
              <li>To provide and maintain our AI voice agent Services</li>
              <li>To process payments and manage your subscription</li>
              <li>To improve our Services and develop new features</li>
              <li>To communicate with you about your account and updates</li>
              <li>To provide customer support</li>
              <li>To comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">3. Call Recordings</h2>
            <div className="text-slate-600 leading-relaxed space-y-4">
              <p><strong>Storage:</strong> Call recordings are stored securely with encryption at rest and in transit.</p>
              <p><strong>Retention:</strong> Recordings are retained for the duration specified in your plan settings, typically 90 days, unless you request longer retention.</p>
              <p><strong>Access:</strong> Only you and authorized users on your account can access your call recordings through the dashboard.</p>
              <p><strong>Deletion:</strong> You may request deletion of call recordings at any time by contacting support.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">4. Data Sharing</h2>
            <p className="text-slate-600 leading-relaxed mb-4">We do not sell your personal information. We may share data with:</p>
            <ul className="list-disc list-inside text-slate-600 space-y-2">
              <li><strong>Service Providers:</strong> Third parties that help us deliver our Services (cloud hosting, payment processing, voice infrastructure)</li>
              <li><strong>Legal Requirements:</strong> When required by law, subpoena, or to protect our rights</li>
              <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">5. Data Security</h2>
            <div className="text-slate-600 leading-relaxed space-y-4">
              <p>We implement industry-standard security measures including:</p>
              <ul className="list-disc list-inside space-y-2">
                <li>Encryption of data in transit (TLS) and at rest (AES-256)</li>
                <li>Access controls and authentication</li>
                <li>Regular security audits and monitoring</li>
                <li>Secure data centers with SOC 2 compliance</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">6. Your Rights</h2>
            <p className="text-slate-600 leading-relaxed mb-4">Depending on your location, you may have the right to:</p>
            <ul className="list-disc list-inside text-slate-600 space-y-2">
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Delete your data</li>
              <li>Export your data</li>
              <li>Opt out of marketing communications</li>
              <li>Restrict or object to certain processing</li>
            </ul>
            <p className="text-slate-600 mt-4">To exercise these rights, contact us at privacy@calyro.ai.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">7. Cookies</h2>
            <p className="text-slate-600 leading-relaxed">
              We use cookies and similar technologies to maintain your session, remember preferences, and analyze usage. You can control cookies through your browser settings.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">8. Children's Privacy</h2>
            <p className="text-slate-600 leading-relaxed">
              Our Services are not directed to children under 18. We do not knowingly collect personal information from children.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">9. Changes to This Policy</h2>
            <p className="text-slate-600 leading-relaxed">
              We may update this Privacy Policy from time to time. We will notify you of material changes via email or through our Services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">10. Contact Us</h2>
            <p className="text-slate-600 leading-relaxed">
              For privacy-related questions or requests:
            </p>
            <div className="mt-4 p-4 bg-slate-50 rounded-lg">
              <p className="text-slate-700 font-medium">Calyro, Inc.</p>
              <p className="text-slate-600">Privacy Team: privacy@calyro.ai</p>
              <p className="text-slate-600">Support: support@calyro.ai</p>
              <p className="text-slate-600">Address: 123 Business Ave, Suite 100, San Francisco, CA 94102</p>
            </div>
          </section>
        </div>

        <div className="mt-8 text-center">
          <Link to="/" className="text-blue-600 hover:underline">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
}
